// Pulled from columbus and modified, need to convert to funtional component later

import React from 'react';
import PropTypes from 'prop-types';

import { CarrierCard } from '@itds/components';
import { Button, Checkbox, Input, Field, Loader, Modal, Select } from '@itds/elements/index.js';
import { Api } from '@brokerage/utils/Api';

class QuoteCustomActionsModal extends React.Component {
  static propTypes = {
    actionTypes: PropTypes.array.isRequired,
    agency: PropTypes.object,
    availableCarrierIds: PropTypes.array,
    availableProductIds: PropTypes.array,
    onClose: PropTypes.func,
    onSave: PropTypes.func,
    quoteAction: PropTypes.object,
    showOpenInModal: PropTypes.bool
  };

  constructor(props) {
    super(props);

    const quote_action = props.quoteAction || {
      label: '',
      action_type: 'simple_url',
      carrier_ids: [],
      product_ids: []
    };

    this.state = {
      // action fields
      action_type: quote_action.action_type,
      carrier_ids: quote_action.carrier_ids,
      error_msg: quote_action.error_msg,
      label: quote_action.label,
      open_in_modal: quote_action.open_in_modal,
      order: quote_action.order,
      product_ids: quote_action.product_ids,
      success_msg: quote_action.success_msg,
      url: quote_action.url,

      // data
      carriers: [],
      filtered_carriers: [],

      // ui related
      errors: [],
      loading_carriers: true
    };
  }

  componentDidMount() {
    const { availableCarrierIds, availableProductIds, quoteAction } = this.props;

    // TODO: Update to load Annuity specific carriers
    Api.loadAnnuityCarriers().then(response => {
      const carriers = response.data;
      const carrier_ids = quoteAction ? quoteAction.carrier_ids : carriers.map(c => c.id);
      const product_ids = quoteAction
        ? quoteAction.product_ids
        : carriers.map(c => c.products.map(p => p.id)).flat();

      this.setState({
        quote_action: this.props.quoteAction,
        loading_carriers: false,
        carriers: carriers.filter(c => availableCarrierIds.includes(c.id)),
        carrier_ids: carrier_ids.filter(id => availableCarrierIds.includes(id)),
        filtered_carriers: carriers.filter(c => availableCarrierIds.includes(c.id)),
        product_ids: product_ids.filter(id => availableProductIds.includes(id))
      });
    });
  }

  _handleSaveClick = () => {
    const { quoteAction } = this.props;
    const { ...payload } = this.state;
    const errors = [];

    if (!payload.label) {
      errors.push('label');
    }

    if (!payload.carrier_ids.length) {
      errors.push('carrier_ids');
    }

    this.setState({ errors });

    if (!errors.length) {
      const params = {
        id: quoteAction ? quoteAction.id : null,
        ...payload
      };

      this.props.onSave({ ...params, order: parseInt(payload.order) });
    }
  };

  _handleFieldChange = (name, e) => {
    this.setState({ [name]: e.target.value });
  };

  _handleCheckboxChange = (name, e) => {
    this.setState({ [name]: e.target.checked });
  };

  _handleCarrierToggle = (carrier, checked) => {
    const is_selected = !checked;
    const carrier_product_ids = carrier.products.map(p => p.id);

    let carrier_ids = [...this.state.carrier_ids];

    let product_ids = [...this.state.product_ids];

    if (is_selected) {
      carrier_ids.push(carrier.id);
      product_ids = product_ids.concat(carrier_product_ids);
    } else {
      carrier_ids = carrier_ids.filter(id => id !== carrier.id);
      product_ids = product_ids.filter(id => !carrier_product_ids.includes(id));
    }

    this.setState({ carrier_ids, product_ids });
  };

  _handleToggleAll = () => {
    this.setState({
      carrier_ids: this.state.carrier_ids.length ? [] : this.state.filtered_carriers.map(c => c.id),
      product_ids: this.state.product_ids.length
        ? []
        : this.state.filtered_carriers.map(c => c.products.map(p => p.id)).flat()
    });
  };

  render() {
    const {
      action_type,
      carrier_ids,
      error_msg,
      label,
      open_in_modal,
      order,
      product_ids,
      success_msg,
      url,
      errors,
      loading_carriers
    } = this.state;

    const { actionTypes, onClose, quoteAction, showOpenInModal } = this.props;

    const styles = this.styles();
    const is_webhook_post = action_type === 'webhook_post';

    const buttons = [
      {
        disabled: !carrier_ids.length,
        children: 'Save',
        onClick: this._handleSaveClick.bind(null, this.state.filtered_carriers),
        style: { marginLeft: 'auto' }
      }
    ];

    return (
      <Modal
        buttons={buttons}
        maxWidth={1400}
        onClose={onClose}
        title={quoteAction ? 'Editing Quote Action' : 'New Quote Action'}
      >
        <div style={styles.modal_content}>
          <div style={styles.fields}>
            <Field label='Type'>
              <Select
                onChange={e => this.setState({ action_type: e.target.value })}
                optionGroups={actionTypes}
                value={action_type}
              />
            </Field>

            <div style={{ display: 'flex' }}>
              <div style={{ marginRight: 10, flex: 1 }}>
                <Field label='Label'>
                  <Input
                    invalid={errors.includes('label')}
                    onChange={this._handleFieldChange.bind(null, 'label')}
                    required={true}
                    value={label}
                  />
                </Field>
              </div>

              <div style={{ width: 100 }}>
                <Field label='Display Order'>
                  <Input
                    onChange={this._handleFieldChange.bind(null, 'order')}
                    placeholder='eg: 1'
                    type='number'
                    value={order}
                  />
                </Field>
              </div>
            </div>

            <>
              <Field label='URL'>
                <Input onChange={this._handleFieldChange.bind(null, 'url')} value={url} />
              </Field>
            </>

            {showOpenInModal ? (
              <div style={{ marginBottom: 20 }}>
                <Checkbox
                  checked={open_in_modal}
                  label='Open inside quoter popup modal'
                  name='open_in_modal'
                  onChange={this._handleCheckboxChange.bind(null, 'open_in_modal')}
                  type='checkbox'
                />
              </div>
            ) : null}

            {is_webhook_post ? (
              <>
                <Field label='Success Message'>
                  <Input
                    onChange={this._handleFieldChange.bind(null, 'success_msg')}
                    type='textarea'
                    value={success_msg}
                  />
                </Field>
                <Field label='Error Message'>
                  <Input
                    onChange={this._handleFieldChange.bind(null, 'error_msg')}
                    type='textarea'
                    value={error_msg}
                  />
                </Field>
              </>
            ) : null}
          </div>

          <div style={styles.content}>
            {loading_carriers ? (
              <Loader />
            ) : (
              <>
                <div style={styles.carriers_panel}>
                  <Button inline={true} onClick={this._handleToggleAll} style={styles.button}>
                    {carrier_ids?.length ? 'Select None' : 'Select All'}
                  </Button>

                  <div style={styles.carriers}>
                    {this.state.filtered_carriers.map(carrier => {
                      const is_selected = carrier_ids.includes(carrier.id);

                      const products = carrier.products.filter(p =>
                        this.props.availableProductIds.includes(p.id)
                      );

                      return (
                        <CarrierCard
                          carrier={carrier}
                          isSelected={is_selected}
                          key={carrier.id}
                          lineOfBusiness='annuities'
                          onClick={this._handleCarrierToggle.bind(null, carrier, is_selected)}
                          onProductsSave={product_ids => this.setState({ product_ids })}
                          products={products}
                          selectedProductIds={product_ids}
                        />
                      );
                    })}
                  </div>
                </div>
              </>
            )}
          </div>
        </div>
      </Modal>
    );
  }

  styles = () => {
    return {
      modal_content: {
        display: 'flex',
        justifyContent: 'space-between',
        overflow: 'hidden'
      },

      fields: {
        width: 400,
        flexShrink: 0,
        padding: 40,
        height: 'calc(100vh - 260px)',
        overflow: 'auto'
      },

      content: {
        overflow: 'auto',
        width: 'calc(100vw - 400px)',
        height: 'calc(100vh - 260px)'
      },
      carriers_panel: {
        padding: '40px 30px'
      },
      carriers: {
        display: 'flex',
        flexWrap: 'wrap'
      },

      button: {
        marginBottom: 20,
        marginLeft: 10
      }
    };
  };
}

export default QuoteCustomActionsModal;
